import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

export const ConfirmModal = ({
  show,
  toggle,
  title,
  message,
  onConfirm,
  confirmText,
  confirmButtonClass,
}) => {
  const handleConfirm = () => {
    toggle(false)
    onConfirm()
  }

  const handleCancel = () => {
    toggle(false)
  }

  return (
    <Modal show={show} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        <div className="text-center">
          <div
            className={confirmButtonClass || 'btn btn-danger btn-myed btn-danger-myed mr-2'}
            onClick={handleConfirm}
          >
            {confirmText || 'Confirm'}
          </div>
          <div
            className="btn btn-default btn-myed mr-2"
            onClick={handleCancel}
          >
            Cancel
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  confirmButtonClass: PropTypes.string,
}
